const SellerReviewBadIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#FFDD67"
      />
      <path
        d="M8.23668 18.5047C8.14091 18.4297 8.06294 18.3345 8.00837 18.2258C7.95381 18.1171 7.92402 17.9977 7.92113 17.8762C7.91824 17.7546 7.94234 17.6339 7.99169 17.5227C8.04103 17.4116 8.1144 17.3128 8.20651 17.2334C8.94571 16.6025 10.2486 15.7714 11.9999 15.7714C13.7512 15.7714 15.0527 16.5943 15.7919 17.2293C15.8841 17.3088 15.9575 17.4079 16.0067 17.5193C16.056 17.6307 16.0799 17.7516 16.0767 17.8734C16.0736 17.9951 16.0435 18.1147 15.9885 18.2234C15.9336 18.3321 15.8552 18.4272 15.759 18.5019C15.6106 18.6177 15.427 18.679 15.2388 18.6758C15.0506 18.6725 14.8692 18.6049 14.7249 18.4841C14.1969 18.037 13.2451 17.4171 11.9999 17.4171C10.7546 17.4171 9.80559 18.0357 9.27348 18.4855C9.1291 18.6071 8.94726 18.6755 8.75849 18.679C8.56971 18.6824 8.38547 18.6209 8.23668 18.5047Z"
        fill="#B26D3C"
      />
      <path
        d="M15.977 12.709C16.8481 12.709 17.5542 12.0029 17.5542 11.1319C17.5542 10.2609 16.8481 9.55475 15.977 9.55475C15.106 9.55475 14.3999 10.2609 14.3999 11.1319C14.3999 12.0029 15.106 12.709 15.977 12.709Z"
        fill="#B26D3C"
      />
      <path
        d="M15.554 6.74995C15.16 6.52363 14.6571 6.65957 14.4308 7.05358C14.2045 7.44759 14.3404 7.95046 14.7344 8.17678L18.1184 10.1205C18.5124 10.3468 19.0153 10.2109 19.2416 9.81688C19.4679 9.42287 19.332 8.92 18.938 8.69368L15.554 6.74995Z"
        fill="#B26D3C"
      />
      <path
        d="M8.02294 12.709C8.89398 12.709 9.60009 12.0029 9.60009 11.1319C9.60009 10.2609 8.89398 9.55475 8.02294 9.55475C7.15191 9.55475 6.4458 10.2609 6.4458 11.1319C6.4458 12.0029 7.15191 12.709 8.02294 12.709Z"
        fill="#B26D3C"
      />
      <path
        d="M8.44261 6.74832L5.05863 8.69205C4.66462 8.91837 4.52868 9.42124 4.755 9.81525C4.98131 10.2093 5.48419 10.3452 5.8782 10.1189L9.26217 8.17515C9.65618 7.94884 9.79212 7.44596 9.56581 7.05195C9.33949 6.65794 8.83662 6.522 8.44261 6.74832Z"
        fill="#B26D3C"
      />
    </svg>
  );
};

export { SellerReviewBadIcon };
